<template>
  <div class="record-table" :class="cssType">
    <div class="thead">
      <div class="tr">
        <div class="td first">{{ props.headers.first }}</div>
        <div class="td second">{{ props.headers.second }}</div>
        <div class="td time">{{ props.headers.time }}</div>
      </div>
    </div>
    <div class="tbody" v-if="props.rows.length">
      <div class="tr" v-for="row in props.rows" :key="row.key">
        <div class="td first">{{ row.first }}</div>
        <div class="td second">
          <template v-if="row.props.length">
            <div class="prop-line" v-for="(prop, idx) in row.props" :key="idx">
              <template v-if="isMobile">
                {{ getPropName(t, prop) || '—' }}<span class="prop-count" v-if="Number(prop.propCount ?? prop.count) > 0">*{{ Number(prop.propCount ?? prop.count) }}</span>
              </template>
              <template v-else>{{ formatPropText(t, prop) }}</template>
            </div>
          </template>
          <span v-else>—</span>
        </div>
        <div class="td time">{{ row.time }}</div>
      </div>
    </div>
    <div class="record-empty" v-else>{{ props.emptyText }}</div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
import { isMobile } from '@/utils'
import { formatPropText, getPropName } from '../../../../utils/prop'

const props = defineProps({
  headers: {
    type: Object,
    default: () => ({}),
  },
  // [{ key, first, props: [...], time }]
  rows: {
    type: Array,
    default: () => [],
  },
  emptyText: {
    type: String,
    default: '',
  },
})

const { t } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
